module.exports = __webpack_public_path__ + "media/components/assets/images/nav_logo-bca7421caa7da623d551c8902519a283.png";